import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { PotentialAssignee } from '../../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { ColumnValue } from '../../../grid/types/common';
import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';
import { AssignedUserType, InvestigationPriority, InvestigationStatus } from '../../../investigation/types';
import { ListItem } from '../../../ui/gzSingleSelectList/types';
import { EnumUtils } from '../../../utils/enum.utils';

export class EasmInventoryBaseViewDataProvider extends BaseWebComponentDataProvider {
  protected stringsTranslator = BaseWebComponentTranslator.getInstance();
  private potentialAssignees: PotentialAssignee[];

  protected getInvestigationStatusOptions(): (ColumnValue | ListItem)[] {
    return EnumUtils.GetNumericValues<InvestigationStatus>(InvestigationStatus).map(
      (investigationStatus: InvestigationStatus): ColumnValue => ({
        label: this.stringsTranslator.translateInvestigationStatus(investigationStatus),
        value: investigationStatus,
      })
    )
  }

  protected async getAssigneeFilterOptions(): Promise<ColumnValue[]> {
    const potentialAssignees = await this.getPotentialAssignees(),
      options = potentialAssignees.map((assignee: PotentialAssignee): ColumnValue => ({
        label: assignee.name,
        value: assignee._id,
      }));

    options.unshift(
      {
        label: this.stringsTranslator.translateInvestigationAssignedUserType(AssignedUserType.UNASSIGNED),
        value: AssignedUserType.UNASSIGNED,
      },
      {
        label: this.stringsTranslator.translateInvestigationAssignedUserType(AssignedUserType.USER_OUTSIDE_MY_COMPANY),
        value: AssignedUserType.USER_OUTSIDE_MY_COMPANY,
      }
    );

    return options;
  }

  protected async getAssigneeOptions(): Promise<ListItem[]> {
    const potentialAssignees = await this.getPotentialAssignees(),
      options = potentialAssignees.map((assignee: PotentialAssignee): ListItem => ({
        label: assignee.name,
        value: assignee._id,
      }));

    options.unshift({
      label: this.stringsTranslator.translateInvestigationAssignedUserType(AssignedUserType.UNASSIGNED),
      value: AssignedUserType.UNASSIGNED,
    });

    return options;
  }

  protected getPriorityOptions(): (ColumnValue | ListItem)[] {
    return EnumUtils.GetNumericValues<InvestigationPriority>(InvestigationPriority).map(
      (investigationPriority: InvestigationPriority): ColumnValue => ({
        label: this.stringsTranslator.translateInvestigationPriority(investigationPriority),
        value: investigationPriority,
      })
    );
  }

  private async getPotentialAssignees(): Promise<PotentialAssignee[]> {
    if (!this.potentialAssignees) {
      this.potentialAssignees = await ConsoleRequest.createRequest<PotentialAssignee[]>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'EASMFindings',
        method: 'getPotentialAssignees',
      });
    }

    return this.potentialAssignees;
  }
}
